"use strict";
import React from "react";
import classNames from "classnames";
import { Button, ButtonSize, ButtonVariant } from "../ui/v3/button";
export default React.createClass({
  startResolving: function() {
    this.setState({ resolving: true });
  },
  cancelResolving: function() {
    this.setState({ resolving: false });
  },
  resolveException: function() {
    var self = this;
    var exception = self.props.exception;
    self.setState({ saving: true });
    self.props.exceptionResolver(
      self.state.resolutionMessage,
      exception,
      self.props.owner
    ).then(function() {
      if (self.isMounted()) {
        self.setState({ saving: false, resolving: false });
      }
    });
  },
  getInitialState: function() {
    return {};
  },
  render: function() {
    if (this.props.v3ReskinEnabled) {
      return this.renderV3Reskin();
    } else {
      var exception = this.props.exception;
      var itemClasses = classNames({
        rules__item: true,
        "rules__item--resolving": this.state.resolving
      });
      var exceptionClasses = classNames({
        rules__ignored: exception.resolved_at,
        "rules__item-text": true,
        "rules__item-text--resolving": this.state.resolving
      });
      return /* @__PURE__ */ React.createElement("li", { className: itemClasses }, /* @__PURE__ */ React.createElement("span", { className: exceptionClasses }, /* @__PURE__ */ React.createElement("span", { className: "text" }, exception.message_override)), this.resolvingException(), this.resolveButton(exception));
    }
  },
  renderV3Reskin: function() {
    let styles = { display: "flex" };
    if (this.state.resolving) {
      styles = Object.assign(styles, {
        flexDirection: "column",
        gap: "16px"
      });
      return /* @__PURE__ */ React.createElement("div", { className: "v3__type__body", style: styles }, this.props.exception.message_override, /* @__PURE__ */ React.createElement("div", { style: { display: "flex" } }, this.resolvingExceptionV3Reskin()));
    } else {
      styles = Object.assign(styles, {
        justifyContent: "space-between",
        gap: "24px"
      });
      return /* @__PURE__ */ React.createElement("div", { className: "v3__type__body", style: styles }, /* @__PURE__ */ React.createElement("div", { style: { alignSelf: "center" } }, this.props.exception.message_override), this.resolveButton(this.props.exception));
    }
  },
  resolvingException: function() {
    if (this.state.resolving) {
      return /* @__PURE__ */ React.createElement("div", { className: "rules__resolve-exception-container" }, /* @__PURE__ */ React.createElement(
        "textarea",
        {
          placeholder: "Resolution Message",
          rows: 4,
          value: this.state.resolutionMessage || "",
          onChange: (e) => this.setState({
            resolutionMessage: e.target.value
          })
        }
      ), this.resolveOrSaveButton(), /* @__PURE__ */ React.createElement("span", { className: "button__cancel-wrapper" }, " ", "or", /* @__PURE__ */ React.createElement("button", { className: "button--cancel", onClick: this.cancelResolving }, "cancel")));
    }
  },
  resolvingExceptionV3Reskin: function() {
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        style: {
          display: "flex",
          gap: "16px",
          flexDirection: "column",
          width: "100%"
        }
      },
      /* @__PURE__ */ React.createElement("div", { className: "v3__input-wrapper" }, /* @__PURE__ */ React.createElement(
        "textarea",
        {
          className: "v3__input",
          placeholder: "Provide a reason",
          value: this.state.resolutionMessage || "",
          onChange: (e) => this.setState({
            resolutionMessage: e.target.value
          }),
          style: { height: "64px" }
        }
      )),
      /* @__PURE__ */ React.createElement(
        "div",
        {
          style: {
            display: "flex",
            flexDirection: "row",
            alignSelf: "flex-end",
            gap: "12px"
          }
        },
        /* @__PURE__ */ React.createElement(
          Button,
          {
            size: ButtonSize.Medium,
            variant: ButtonVariant.Text,
            onClick: this.cancelResolving,
            style: { padding: "0" }
          },
          "Cancel"
        ),
        this.resolveOrSaveButtonV3Reskin()
      )
    );
  },
  resolveButton: function(exception) {
    if (!exception.resolved_at && !this.state.resolving && this.props.exceptionResolver) {
      const owner = this.props.owner || {};
      const message = owner.ignored ? "Resolve and Remove Ignore" : "Resolve";
      if (this.props.v3ReskinEnabled) {
        return /* @__PURE__ */ React.createElement(
          Button,
          {
            size: ButtonSize.Medium,
            variant: ButtonVariant.Outlined,
            onClick: this.startResolving
          },
          message
        );
      } else {
        return /* @__PURE__ */ React.createElement(
          "button",
          {
            onClick: this.startResolving,
            className: "rules__resolve-button"
          },
          message
        );
      }
    }
  },
  resolveOrSaveButton: function() {
    if (this.state.saving) {
      return this.savingButton();
    } else {
      return /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "rules__save-resolution-button",
          onClick: this.resolveException
        },
        "Resolve Exception"
      );
    }
  },
  resolveOrSaveButtonV3Reskin: function() {
    if (this.state.saving) {
      return /* @__PURE__ */ React.createElement(
        Button,
        {
          size: ButtonSize.Medium,
          variant: ButtonVariant.Outlined,
          disabled: true
        },
        "Saving..."
      );
    } else {
      return /* @__PURE__ */ React.createElement(
        Button,
        {
          size: ButtonSize.Medium,
          variant: ButtonVariant.Outlined,
          onClick: this.resolveException
        },
        "Resolve"
      );
    }
  },
  savingButton: function() {
    return /* @__PURE__ */ React.createElement("button", { disabled: true }, "Saving...");
  }
});
